import React from 'react';
import './styles.css';

const Footer = () => (
  <footer>
    <div className="footer-page">
      &copy; 2022 | Emmanuel &  Bunbe
    </div>
  </footer>
);

export default Footer;
